@if (contact.isRegisterOnPortal) {
<div class="checkbox">
    @if (!isHide) {
    <por-base-checkbox [isChecked]="checked" (checkboxChange)="onCheckboxChange($event)" [showLabel]="false"></por-base-checkbox>
    }
</div>
}
